const angularRouteRegexps = [
  /^\/sign_in/,
  /^\/registration/,
  /^\/passwords/,
  /^\/unsubscribe/,
  /^\/affiliate_ref/,
];

export default function mapAngularLink(): Promise<string | undefined> {
  return new Promise<string | undefined>((resolve) => {
    try {
      const hash = window.location.hash.replace('#', '');

      if (hash && angularRouteRegexps.some((item) => item.test(hash))) {
        resolve(hash);
        return;
      }
    } catch {}

    resolve(undefined);
  });
}
